import axios from "axios";

interface ContactResponse {
  success: boolean;
  message: string;
}

export const sendContactForm = async (formData: {
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  message: string;
}): Promise<ContactResponse | null> => {
  try {
    const response = await axios.post<ContactResponse>(
      `${process.env.NEXT_PUBLIC_BASE_URL}/api/contact/`,
      formData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("API request error:", error);
    return null;
  }
};
